angular.module('dpw.components')
    /**
     * @ngdoc service
     * @name dpwSwitcherUtils
     * @description
     * Utilities for dpwSwitcher component.
     */
    .factory('dpwSwitcherUtils', function () {
        var utils = {
            /**
             * @ngdoc method
             * @name dpwSwitcherUtils#getBuiltInStyle
             * @description
             * Get built-in styles.
             *
             * @param {String} styleName
             * @see _switcher.sass for built-in styles
             * @returns {string}
             */
            getBuiltInStyle: function (styleName) {
                var BUILT_IN_STYLES = ['tabCard', 'tabLine'];

                return _.some(BUILT_IN_STYLES, function (item) {
                    return item === styleName;
                }) ? 'dpw-switcher-' + styleName : '';
            },

            /**
             * @ngdoc method
             * @name dpwSwitcherUtils#attachEvent
             * @description
             * Attach on click event for item. The data structure for items is:
             * [
             *   { label: 'Label', active: true, action: function, disabled: false, href: '' },
             *   ...
             * ]
             *
             * Active and href are exclusive. If they present in a item, the action will be respected.
             *
             *
             * @param {Array} items
             */
            attachEvent: function (items) {
                _.map(items, function (item) {
                    if (item.disabled) {
                        item.onClick = function ($event) {
                            $event.preventDefault();
                        };
                        return;
                    }

                    item.onClick = !isLink(item) ? function ($event) {
                        $event.preventDefault();
                        utils.activeItem(items, item);
                        item.action();
                    } : function () {
                        utils.activeItem(items, item);
                    };
                });

                function isLink (item) {
                    return !_.isFunction(item.action) && !!item.href;
                }
            },

            /**
             * @ngdoc method
             * @name dpwSwitcherUtils#activeItem
             * @description
             * Activate item and deactivate other items.
             *
             * @param {Array} items
             * @param {Object} item
             */
            activeItem: function (items, item) {
                _.map(items, function (item) {
                    item.active = false;
                });
                item.active = true;
            },

            /**
             * @ngdoc method
             * @name dpwSwitcherUtils#ensureActive
             * @description
             * Activate first item when items are all inactive.
             *
             * @param {Array} items
             */
            ensureActive: function (items) {
                var noActiveItem = _.every(items, function (item) {
                    return !item.active;
                });

                if (noActiveItem && items.length > 0) {
                    items[0].active = true;
                }
            }
        };

        return utils;

    })

    /**
     * @ngdoc directive
     * @name dpwSwitcher
     * @restrict EA
     * @param {Array} items
     * @param {String} switcherStyle - tabCard | tabLine
     * @param {String} extraClass
     * @description
     * Switcher Component.
     *
     * The data structure for items is:
     * [
     *   { label: 'Label', active: true, action: function, disabled: false, href: '' },
     *   ...
     * ]
     *
     * @example
     * <div dpw-switcher="itemsInControllerOrScope"
     *      switcher-style="tabCard" extraClass="something"></div>
     */
    .directive('dpwSwitcher', ['dpwSwitcherUtils', function (dpwSwitcherUtils) {
        return {
            restrict: 'EA',
            scope: {
                items: '=dpwSwitcher',
                switcherStyle: '@',
                extraClass: '@'
            },
            bindToController: true,
            controllerAs: 'ctrl',
            templateUrl: 'dpw-switcher.html',
            controller: [function () {
                var vm = this;
                var utils = dpwSwitcherUtils;
                var items = vm.items;

                vm.style = utils.getBuiltInStyle(vm.switcherStyle);
                vm.extraClass = vm.extraClass || '';

                utils.attachEvent(items);
                utils.ensureActive(items);
            }]
        };
    }]);